module.exports = __webpack_public_path__ + "static/media/add-photo.284f3694.svg";